var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKingBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9V14.25C21 14.664 20.664 15 20.25 15C19.836 15 19.5 14.664 19.5 14.25V13.5H1.5V14.25C1.5 14.664 1.164 15 0.75 15C0.336 15 0 14.664 0 14.25V9C0 7.7595 1.0095 6.75 2.25 6.75H18.75C19.9905 6.75 21 7.7595 21 9Z",
    fill: "#c5c5c5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25V0.75C2.25 0.336 2.586 0 3 0H18C18.414 0 18.75 0.336 18.75 0.75V5.25H16.5V4.5C16.5 3.67275 15.8273 3 15 3H12.75C11.9227 3 11.25 3.67275 11.25 4.5V5.25H9.75V4.5C9.75 3.67275 9.07725 3 8.25 3H6C5.17275 3 4.5 3.67275 4.5 4.5V5.25H2.25Z",
    fill: "#c5c5c5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingBed);
export default __webpack_public_path__ + "static/media/king-bed.8cd444642fc1fb9e27223e9dbea3e975.svg";
export { ForwardRef as ReactComponent };